@if (isHoveredMode) {
<div class="rail-backdrop"></div>
}
<div #subSidebar class="sub-sidebar"
  [class.collapsed]="isCollapsed || (activeParentName !== 'Home' && subMenus.length === 0 && groupedMasters.length === 0)"
  [class.hover-popover]="isHoveredMode" [style.top.px]="isHoveredMode ? hoverTop : null" (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()">

  <!-- Header -->
  <div class="sub-sidebar-header">

    @if (!isSearchVisible) {
    <h3 class="sub-sidebar-title">{{ activeParentName }}</h3>

    <div class="header-actions">
      <button class="header-action-btn" (click)="toggleSearch()" title="Search Menu">
        <i class="hgi hgi-stroke hgi-rounded hgi-search-01"></i>
      </button>

      <button class="header-action-btn collapse-btn" (click)="collapseSidebar()" title="Collapse Menu">
        <i class="hgi hgi-stroke hgi-rounded hgi-arrow-left-double"></i>
      </button>
    </div>
    }

    @if (isSearchVisible) {
    <div class="header-search-wrapper">
      <i class="hgi hgi-stroke hgi-rounded hgi-search-01 header-search-icon"></i>

      <label for="sub-sidebar-search" class="visually-hidden">Search menu</label>
      <input type="text" id="sub-sidebar-search" class="header-search-box" placeholder="Search..." [(ngModel)]="searchTerm"
        (keyup)="filterSubMenus()" autofocus />

      <button type="button" class="header-search-close" (click)="toggleSearch()" title="Close Search">
        <i class="hgi hgi-stroke hgi-rounded hgi-cancel-01"></i>
      </button>
    </div>
    }

  </div>

  <!-- Content Panel -->
  <div class="sub-sidebar-content">
    <!-- CASE 1: Active Parent is Home -->
    @if (activeParentName === 'Home') {
      @if (isCustomSidebarSupported && customizedConfig) {
        @for (sec of customizedConfig.sections; track sec.id) {
          @if (sec.enabled && sec.items.length > 0) {
          <div class="custom-sub-section mb-3">
            <div class="accordion-header pb-1" (click)="toggleGroup(sec.name)">
              <span class="group-title text-uppercase">{{ sec.name }}</span>
              <i class="hgi hgi-stroke hgi-rounded" [class.hgi-arrow-up-01]="isGroupExpanded(sec.name)"
                [class.hgi-arrow-down-01]="!isGroupExpanded(sec.name)"></i>
            </div>

            @if (isGroupExpanded(sec.name)) {
            <ul class="submenu-list">
              @for (item of sec.items; track item.id) {
                @if (item.enabled) {
                <li class="submenu-item">
                  @if (isExternalUrl(item.link)) {
                  <a class="submenu-link d-flex align-items-center" [href]="item.link" target="_blank" rel="noopener noreferrer">
                    <i [class]="item.icon || 'hgi hgi-stroke hgi-rounded hgi-link-01'" class="me-2" style="font-size: 14px; opacity: 0.8;"></i>
                    <span>{{ item.name }}</span>
                    <i class="hgi hgi-stroke hgi-rounded hgi-arrow-up-right-01 ms-auto" style="font-size: 12px; opacity: 0.6;"></i>
                  </a>
                } @else {
                  <a class="submenu-link d-flex align-items-center" [routerLink]="item.link" routerLinkActive="active-submenu-link"
                    [routerLinkActiveOptions]="{ exact: false }" (click)="setCustomMenuId(item)">
                    <i [class]="item.icon || 'hgi hgi-stroke hgi-rounded hgi-link-01'" class="me-2" style="font-size: 14px; opacity: 0.8;"></i>
                    <span>{{ item.name }}</span>
                  </a>
                }
                </li>
                }
              }
            </ul>
            }
          </div>
          }
        }

        <!-- Customise Sidebar Button at Bottom of Sub-sidebar -->
        <div class="customize-btn-wrapper mt-4 mb-3">
          <button type="button" class="btn-customize-sidebar" (click)="openCustomizeSidebarModal()">
            <i class="hgi hgi-stroke hgi-rounded hgi-settings-02"></i>
            Customise Sidebar
          </button>
        </div>
      } @else {
        <!-- Fallback Quick Links Accordion -->
        <div class="accordion-group">
          <div class="accordion-header" (click)="toggleGroup('Quick Links')">
            <span class="group-title">Quick Links</span>
            <i class="hgi hgi-stroke hgi-rounded" [class.hgi-arrow-up-01]="isGroupExpanded('Quick Links')"
              [class.hgi-arrow-down-01]="!isGroupExpanded('Quick Links')"></i>
          </div>
          @if (isGroupExpanded('Quick Links')) {
          <div class="accordion-body">
            <ul class="submenu-list">
              @for (submenu of filteredSubMenus; track submenu.id) {
              <li class="submenu-item">
                <a class="submenu-link" [routerLink]="submenu.link" routerLinkActive="active-submenu-link"
                  [routerLinkActiveOptions]="{ exact: false }" (click)="setMenuId(submenu.id)">
                  {{ submenu.name }}
                </a>
              </li>
              }
            </ul>
          </div>
          }
        </div>
      }
    } @else if (groupedMasters.length > 0) {
    <!-- CASE 2: Active Parent is Masters (ID 16) -->
    @for (group of filteredGroupedMasters; track group.groupName) {
    <div class="accordion-group">
      <div class="accordion-header" (click)="toggleGroup(group.groupName)">
        <span class="group-title">{{ group.groupName }}</span>
        <i class="hgi hgi-stroke hgi-rounded" [class.hgi-arrow-up-01]="isGroupExpanded(group.groupName)"
          [class.hgi-arrow-right-01]="!isGroupExpanded(group.groupName)"></i>
      </div>
      @if (isGroupExpanded(group.groupName)) {
      <div class="accordion-body">
        <ul class="submenu-list">
          @for (submenu of group.menus; track submenu.id) {
          <li class="submenu-item">
            <a class="submenu-link" [routerLink]="submenu.link" routerLinkActive="active-submenu-link"
              [routerLinkActiveOptions]="{ exact: false }" (click)="setMenuId(submenu.id)">
              {{ submenu.name }}
            </a>
          </li>
          }
        </ul>
      </div>
      }
    </div>
    }
    } @else if (isMyTeam) {
    <!-- CASE 3: My Team with 3rd-Level Parent Accordions -->
    <ul class="submenu-list no-group">
      @for (item of filteredSubMenus; track item.id) {
        @if (item.hasChildren) {
        <li class="submenu-accordion-wrapper">
          <div class="accordion-header" (click)="toggleGroup(item.name)">
            <div class="accordion-title-wrap">
              @if (item.icon) {
                <i [class]="item.icon" class="menu-icon"></i>
              }
              <span class="group-title">{{ item.name }}</span>
            </div>
            <i class="hgi hgi-stroke hgi-rounded accordion-arrow"
              [class.hgi-arrow-up-01]="isGroupExpanded(item.name)"
              [class.hgi-arrow-down-01]="!isGroupExpanded(item.name)"></i>
          </div>

          @if (isGroupExpanded(item.name)) {
          <div class="accordion-body">
            <ul class="submenu-list nested-level-3">
              @for (child of item.children; track child.id) {
              <li class="submenu-item">
                <a class="submenu-link" [routerLink]="child.link" routerLinkActive="active-submenu-link"
                  [routerLinkActiveOptions]="{ exact: false }" (click)="setMenuId(child.id)">
                  <span class="bullet-dot">•</span>
                  {{ child.name }}
                </a>
              </li>
              }
            </ul>
          </div>
          }
        </li>
        } @else if (item.link) {
        <li class="submenu-item">
          <a class="submenu-link" [routerLink]="item.link" routerLinkActive="active-submenu-link"
            [routerLinkActiveOptions]="{ exact: false }" (click)="setMenuId(item.id)">
            @if (item.icon) {
              <i [class]="item.icon" class="me-2"></i>
            }
            {{ item.name }}
          </a>
        </li>
        }
      }
    </ul>
    } @else {
    <!-- CASE 4: Flat Submenus (Other Modules) -->
    <ul class="submenu-list no-group">
      @for (submenu of filteredSubMenus; track submenu.id) {
      <li class="submenu-item">
        <a class="submenu-link" [routerLink]="submenu.link" routerLinkActive="active-submenu-link"
          [routerLinkActiveOptions]="{ exact: false }" (click)="setMenuId(submenu.id)">
          @if (submenu.icon) {
          <i [class]="submenu.icon" class="me-2"></i>
          }
          {{ submenu.name }}
        </a>
      </li>
      }
    </ul>
    }
  </div>
</div>

<!-- Customized Sidebar Column Configuration Modal -->
<app-customized-sidebar
  [isOpen]="isCustomizeModalOpen"
  (close)="isCustomizeModalOpen = false"
  (save)="onCustomizedSidebarSave($event)"
></app-customized-sidebar>
